var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronLeftColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95107 3.12793C5.87569 3.04994 5.77713 3.00195 5.66697 3.00195C5.44086 3.00195 5.26693 3.18192 5.26693 3.41587C5.26693 3.52985 5.30751 3.63782 5.37708 3.70981L9.73703 8.00495L5.37708 12.2881C5.30751 12.3661 5.26693 12.4801 5.26693 12.588C5.26693 12.822 5.44086 13.002 5.66697 13.002C5.77713 13.002 5.8699 12.954 5.95107 12.876L10.5777 8.32889C10.6647 8.2389 10.7227 8.12493 10.7227 7.99895C10.7227 7.87297 10.6705 7.77099 10.5777 7.67502L5.95107 3.12793Z",
    fill: "white",
    stroke: "#1080FF",
    strokeWidth: 0.96639
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftColor);
export default __webpack_public_path__ + "static/media/chevron_left_color.d9e1a948c38144ba376581e01add622c.svg";
export { ForwardRef as ReactComponent };